import { ArrowRight, BellRing, History, MessageSquarePlus, RadioTower, Users, Wand2 } from "lucide-react";
import { Link } from "react-router-dom";
import { canManageChannels, canManageUsers, useAuth } from "../lib/auth";

const actions = [
  {
    to: "/create",
    title: "Create Card",
    body: "สร้างโพสต์พร้อม media, caption และ inline buttons",
    icon: MessageSquarePlus
  },
  {
    to: "/history",
    title: "History",
    body: "ดูผลการส่ง Telegram พร้อม message id และ error",
    icon: History
  },
  {
    to: "/templates",
    title: "Templates",
    body: "เก็บแพทเทิร์นการ์ดไว้ใช้ซ้ำในทีม",
    icon: Wand2
  },
  {
    to: "/scheduled",
    title: "Scheduled",
    body: "โครงพร้อมสำหรับ Phase 3 และ Cron Trigger",
    icon: BellRing
  }
];

export function Dashboard() {
  const { user } = useAuth();
  const roleActions = [
    ...actions,
    ...(canManageChannels(user)
      ? [{ to: "/channels", title: "Channels", body: "ตั้งค่า Telegram channel ที่ส่งได้", icon: RadioTower }]
      : []),
    ...(canManageUsers(user)
      ? [{ to: "/users", title: "Users", body: "เพิ่มผู้ใช้ รีเซ็ตรหัสผ่าน และกำหนด role", icon: Users }]
      : [])
  ];

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold text-ink">Dashboard</h1>
          <p className="mt-1 text-sm text-slate-500">Phase 1 พร้อมสำหรับ setup, login, user, channel, create, send now และ history</p>
        </div>
        <Link to="/create" className="inline-flex items-center gap-2 rounded bg-brand px-4 py-2 text-sm font-semibold text-white hover:bg-teal-800">
          <MessageSquarePlus size={17} />
          New Card
        </Link>
      </div>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {roleActions.map((action) => {
          const Icon = action.icon;
          return (
            <Link key={action.to} to={action.to} className="group rounded border border-line bg-white p-5 shadow-sm transition hover:border-brand hover:shadow-soft">
              <div className="mb-4 flex h-11 w-11 items-center justify-center rounded bg-brand/10 text-brand">
                <Icon size={22} />
              </div>
              <div className="flex items-center justify-between gap-3">
                <h2 className="text-lg font-semibold text-ink">{action.title}</h2>
                <ArrowRight className="text-slate-400 transition group-hover:translate-x-1 group-hover:text-brand" size={18} />
              </div>
              <p className="mt-2 text-sm leading-6 text-slate-500">{action.body}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
